/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

/**
 * Query-string keys for the product filter/search state. Shared by
 * {@link useProductFilters} (which reads/writes them on the products pages) and
 * by producers that navigate into those pages (e.g. the home-page search bar),
 * so the param names stay in one place.
 */
export const PARAM_KEYS = {
  search: "s",
  category: "category",
  tab: "tab",
  page: "page",
  sortBy: "st",
  dateFrom: "df",
  dateTo: "dt",
  priceFrom: "pf",
  priceTo: "pt",
  inStock: "inStock",
  promotion: "promotion",
} as const;

/**
 * Phase 1 of the Promotion filter offers a single, hardcoded option. The label is
 * what the user sees in the dropdown/chip; the value written to the query comes
 * from the `traderDealsFilterValue` remote-config key.
 */
export const PROMOTION_TRADER_LABEL = "Trader";

/**
 * Order of the tabs on the Shop page. The index is persisted as the `tab` URL param
 * (see {@link useProductFilters}).
 */
export enum ProductTabIndex {
  All = 0,
  Past = 1,
}
